import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { PassageiroApiService } from "./shared/passageiro-api.service";
import { PassageiroListComponent } from "./passageiro-list/passageiro-list.component";
import { PassageirosRoutingModule } from "./passageiros-routing.module";
import { PassageiroFormComponent } from './passageiro-form/passageiro-form.component';
import { PassageiroNavigationService } from "./shared/passageiro-navigation.service";
import { PassageiroService } from "./shared/passageiro.service";
import { PassageirosComponent } from "./passageiros.component";
import { EnderecosModule } from "../../estruturas/enderecos/enderecos.module";
import { PassageiroDeslocamentoFormListComponent } from "./passageiro-deslocamento-form-list/passageiro-deslocamento-form-list.component";

@NgModule({
    imports: [
        SharedModule,
        EnderecosModule,
        PassageirosRoutingModule
    ],
    providers: [
        PassageiroApiService,
        PassageiroNavigationService,
        PassageiroService
    ],
    declarations: [
        PassageirosComponent,
        PassageiroListComponent,
        PassageiroFormComponent,
        PassageiroDeslocamentoFormListComponent
    ],
    exports: [
        PassageiroDeslocamentoFormListComponent
    ]
})
export class PassageirosModule {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/passageiros.module.ts
 **/